module.exports = __webpack_public_path__ + "img/svg/background-ranked-classification-mobile.81ca2b9b076a6b90100700fc087ada67.svg";